import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import Loadingcontainer from '../loadingcontainer';
import Drilldownplaceholder from '../drilldownplaceholder';
import { updateAppState, updateComponentState } from '../../actions/actions';
import { dateFilter } from '../../utils/services';

class Circulars extends Component {
	constructor(props) {
		super(props);
		this.state = {
			result : [],
            loaderflag : true
		};
		this.onload = this.onload.bind(this);
		this.listbodyRef = this.listbodyRef.bind(this);
		this.renderTableHeaderRow = this.renderTableHeaderRow.bind(this);
	}

	componentWillMount() {
		this.onload();
	}

	onload(){
		if(this.props.componentdata){
			this.setState({
				...this.props.componentdata
			});
		}else{
            this.setState({loaderflag:true});
			axios.get(`/api/circulars`).then((response) => {
				if (response.data.message == 'success') {
					
					let result=[];

					if(response.data.main && response.data.main.length > 0){
						result = response.data.main;
					}
					
					this.setState({
						result,loaderflag : false
					});
					this.props.updateComponentState(this.props.form,{
						result,loaderflag : false
					});
				} else {
					console.log(response);
				}
			});
		}
	}

	renderTableHeaderRow() {
		return (
			<thead>
				<tr>
					<th className="text-center table-header">Circular No</th>
					<th className="text-center table-header">Date</th>
					<th className="text-center table-header">Subject</th>
					<th className="text-center table-header">Attachment</th>
				</tr>
			</thead>
		);
	}

	listbodyRef(node) {
		if(node) {
			node.addEventListener('scroll', (evt) => {
				this.refs.listheader.scrollLeft = evt.srcElement.scrollLeft;
			});
		}
	}

	componentDidMount () {
		setTimeout(() => {
			let table_header_width = document.getElementsByClassName('trimed-table_body') ? document.getElementsByClassName('trimed-table_body')[0].clientWidth : 0;
			this.setState({ table_header_width });
		}, 300);
		window.addEventListener('resize', this.updateWindowSize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowSize);
	}

	updateWindowSize = () => {
		this.setState((prevState) => {
			return {
				duplicatereload: !prevState.duplicatereload
			}
		});
	}

	render() {

		let { result,loaderflag } = this.state;

		let table_body_height = $(window).outerHeight() - $('.header').outerHeight() -$('.page_title').outerHeight() - $('.gs-custom-tab').outerHeight() - 60;

		let isTableHasScrollbar = $('.trimed_table_container').outerHeight() < $('.trimed-table_body').outerHeight() ? true : false;

		let tablebody_scrollWidth = $('.table_body_wrapper').outerWidth() - $('.trimed-table_body').outerWidth();

		return (
			<div className="row">
				<div className="col-lg-12 col-md-12">
					<Loadingcontainer isloading={loaderflag}></Loadingcontainer>
					<div className="row page_title">
						<div className="col-lg-12 col-md-12" >
							<div className="d-flex flex-row justify-content-between margintop-10 marginbottom-10 card-details-header">
								<div>
									<div className="cursor-ptr" style={{color: "#FFFFFF",float: "left"}} onClick={()=>{this.props.history.push('/');}}>
										<div style={{float: "left",width: "25px",height: "25px",background: "#0EC98D",textAlign: "center",borderRadius: "2px 0px 0px 2px"}}>
											<img src="./images/home-btn-icon.svg"/>
										</div>
										<div style={{float: "left",width: "50px",height: "25px",background: "#11E4A1",borderRadius: "0px 2px 2px 0px",fontFamily: "Poppins",fontStyle: "normal",fontWeight: "600",fontSize: "13px",padding: "4px"}}>
											Home
										</div>
									</div>
								</div>
								<div className=" drilldown-header" style={{textAlign:"center",float:"left",fontFamily: "Poppins",fontStyle: "normal",fontSize:"20px"}}>
										Circulars
								</div>
								<div></div>
							</div>
						</div>
					</div>
					<div className="row no-gutters">
						{
							(result && result.length > 0) ?
								<div className="col-lg-12 col-md-12" style={{backgroundColor: '#fff'}}>
									<div className="row no-gutters" style={{padding: '20px'}}>
										<div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 trimed_table_container">
											<div className="trimed-table-wrapper" ref="listheader" style={{width: `${isTableHasScrollbar && tablebody_scrollWidth > 1 ? `calc(100% - ${tablebody_scrollWidth}px)` : '100%'}`}}>
												<table className="table table-bordered trimed-table">
													<colgroup>
														<col style={{width: '30%'}} />
														<col style={{width: '20%'}} />
														<col style={{width: '50%'}} />
														<col style={{width: '10%'}} />
													</colgroup>
													{this.renderTableHeaderRow()}
												</table>
											</div>
											<div className="table_body_wrapper" ref={this.listbodyRef} style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}>
												<table className="table table-hover table-bordered trimed-table trimed-table_body">
													<colgroup>
														<col style={{width: '30%'}} />
														<col style={{width: '20%'}} />
														<col style={{width: '50%'}} />
														<col style={{width: '10%'}} />
													</colgroup>
													{this.renderTableHeaderRow()}
													<tbody>
														{result.map((item, key) => {
															return <tr key={key}>
																<td className="text-center table-content drilldowngroup">{item.circularno}</td>
																<td className="text-center table-content">{dateFilter(item.circulardate)}</td>
																<td className="text-center table-content">{item.circularsubject}</td>
																<td className="text-center table-content">
																	{
																		(item.circularurl) ? <a role="button" class="btn btn-default" style={{color: "#444",background: "#D3D3D3"}} href={item.circularurl} data-toggle="tooltip" title={item.circularname} target="_blank"><span className="fa fa-paperclip"></span></a> : null
																	}
																</td>
															</tr>
														})}
													</tbody>
												</table>
											</div>
										</div>
									</div>
								</div>
							: <div className="col-lg-12 col-md-12" style={{backgroundColor: '#fff'}}><div style={{width: '100%', position: 'relative', height: `${table_body_height}px`, maxHeight: `${table_body_height}px`, overflow: 'auto'}}><Drilldownplaceholder reportdata={result}></Drilldownplaceholder></div></div>
						}
					</div>
				</div>
			</div>
		);
	}
}

Circulars = connect(
	(state, props) => {
		let formName = 'circulars';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState,updateComponentState }
)(reduxForm()(Circulars));

export default Circulars;


// WEBPACK FOOTER //
// ./public/react/components/drilldowns/circulars.js